import React, { useEffect, useState } from "react";

// External Libraries
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Modal } from "react-bootstrap";

// Internal Components
import Button from "components/Buttons/index";
import Icon from "components/Icon/Icon";
import { CaretLeftIcon, CaretRightIcon } from "@phosphor-icons/react";
import { DateRangePickerModal } from "./styled";

// Assets
// import { DownArrow } from "assets/images/SVGComponents";

const CustomDateModal = ({
  show = false,
  onClose,
  onApply,
  initialRange = [null, null],
  showMonth = 2
}) => {
  const [dateRange, setDateRange] = useState(initialRange);

  useEffect(() => {
    setDateRange(initialRange);
  }, [initialRange]);

  const [start, end] = dateRange;

  const today = new Date();
  // const isSecondMonthVisible = (monthDate: Date) => {
  //   const nextMonth = new Date(
  //     monthDate.getFullYear(),
  //     monthDate.getMonth() + 1,
  //     1
  //   );
  //   return nextMonth <= today;
  // };

  const baseOpenDate = end || today;

  return (
    <DateRangePickerModal
      show={show}
      onHide={onClose}
      className="centered-modal"
      backdrop="static"
      keyboard={false}
      unmountOnExit
    >
      <Modal.Body>
        <DatePicker
          className={
            showMonth > 1 ? "multi-month-picker" : "single-month-picker"
          }
          calendarClassName={
            showMonth > 1 ? "calendar-multi-month" : "calendar-single-month"
          }
          selected={start}
          onChange={(update) => setDateRange(update)}
          startDate={start}
          endDate={end}
          selectsRange
          monthsShown={showMonth}
          inline
          maxDate={today}
          openToDate={
            new Date(
              baseOpenDate.getFullYear(),
              baseOpenDate.getMonth() - (showMonth - 1),
              1
            )
          }
          renderCustomHeader={({
            monthDate,
            customHeaderCount,
            decreaseMonth,
            increaseMonth
          }) => {
            const isSingleMonth = showMonth === 1;
            const isFirstMonth = customHeaderCount === 0;
            const isLastMonth = customHeaderCount === showMonth - 1;

            const isFutureMonth =
              monthDate.getFullYear() > today.getFullYear() ||
              (monthDate.getFullYear() === today.getFullYear() &&
                monthDate.getMonth() > today.getMonth());

            const isNextMonthDisabled =
              monthDate.getMonth() === today.getMonth() &&
              monthDate.getFullYear() === today.getFullYear();

            return (
              <div className="custom-datepicker-header">
                {/* LEFT ARROW */}
                {(isSingleMonth || isFirstMonth) && (
                  <div onClick={decreaseMonth} className="nav-arrow prev">
                    <Icon component={CaretLeftIcon} size={16} />
                  </div>
                )}

                <span className="month-label">
                  {monthDate.toLocaleString("default", {
                    month: "long",
                    year: "numeric"
                  })}
                </span>

                {/* RIGHT ARROW */}
                {(isSingleMonth || isLastMonth) &&
                  !isFutureMonth &&
                  !isNextMonthDisabled && (
                    <div onClick={increaseMonth} className="nav-arrow next">
                      <Icon component={CaretRightIcon} size={16} />
                    </div>
                  )}
              </div>
            );
          }}
        />
      </Modal.Body>

      {showMonth > 1 && (
        <Modal.Footer className={showMonth === 2 ? "two-month-footer" : ""}>
          <div className="show-date-range-wrapper">
            <input
              type="text"
              className={`form-control ${start ? "has-value" : ""} ${
                end ? "active-start" : ""
              }`}
              placeholder="Start Date"
              value={start ? start.toLocaleDateString() : ""}
              readOnly
              name="start_date"
            />
            <span className="divider">-</span>
            <input
              type="text"
              className={`form-control ${end ? "has-value" : ""}`}
              placeholder="End Date"
              value={end ? end.toLocaleDateString() : ""}
              readOnly
              disabled={!end}
              name="end_date"
            />
          </div>

          <div className="footer-button-wrapper custom-date-footer">
            <Button
              variant="secondary"
              onClick={() => {
                setDateRange(initialRange);
                if (dateRange) {
                  onClose?.();
                }
              }}
              className="cancel-btn-date-range"
            >
              Cancel
            </Button>
            <Button
              className="ms-2"
              disabled={!start || !end}
              onClick={() => {
                if (onApply) onApply(dateRange);
                onClose?.();
              }}
            >
              Apply
            </Button>
          </div>
        </Modal.Footer>
      )}
    </DateRangePickerModal>
  );
};

export default CustomDateModal;
